import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { FormattedMessage } from 'react-intl';

export const RegisterInformationBanner = () => {
  return (
    <div className="rounded-md px-0 mb-3">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon className="h-5 w-5 text-blue-400" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-700">
            <FormattedMessage id="allDataCanModifiedLater" />
          </p>
        </div>
      </div>
    </div>
  );
};
